import { render } from "./PaymentStatusTable.vue?vue&type=template&id=adda2674"
import script from "./PaymentStatusTable.vue?vue&type=script&lang=js"
export * from "./PaymentStatusTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__